var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{style:({ backgroundColor: _vm.cor, color: _vm.cor})},[_c('div',{staticClass:"color"})])}
var staticRenderFns = []

export { render, staticRenderFns }